import { Box, Link, Typography } from '@mui/material';
import React from 'react';
import { STATIC_ROUTES } from '../../../routes/Routes';

export default function LegaleseLinks() {
  return (
    <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center' }}>
      <Link target="_blank" href={STATIC_ROUTES.TERMS_OF_SERVICE_URL}>
        <Typography sx={{ color: 'black' }} variant="caption">
          Terms Of Service
        </Typography>
      </Link>
      <Link target="_blank" href={STATIC_ROUTES.PRIVACY_POLICY_URL}>
        <Typography sx={{ color: 'black' }} variant="caption">
          Privacy Policy
        </Typography>
      </Link>
    </Box>
  );
}
